"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTIFICATION_CARD_WIDTH = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/prefer-default-export
var NOTIFICATION_CARD_WIDTH = (0, _rem.default)(_spacing.default.base * 34);
exports.NOTIFICATION_CARD_WIDTH = NOTIFICATION_CARD_WIDTH;